import { render, staticRenderFns } from "./EventStatsRow.vue?vue&type=template&id=025610b9&scoped=true&"
import script from "./EventStatsRow.vue?vue&type=script&lang=js&"
export * from "./EventStatsRow.vue?vue&type=script&lang=js&"
import style0 from "./EventStatsRow.vue?vue&type=style&index=0&id=025610b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025610b9",
  null
  
)

export default component.exports